async function parseShopifyCartAddResponse(response) {
	const text = await response.text();
	try {
		return JSON.parse(text);
	} catch {
		const snippet = text.slice(0, 120).trim();
		const looksLikeHtml =
			snippet.startsWith('<') || snippet.toUpperCase().includes('<!DOCTYPE');
		throw new Error(
			looksLikeHtml
				? 'The store could not complete that request. Please refresh the page and try again.'
				: 'Could not add this item to your cart.'
		);
	}
}

// Simple direct approach - no classes, no complications
document.addEventListener('DOMContentLoaded', function () {
	console.log('Product quantity fix loaded');

	// Get elements by ID or data attributes instead of classes
	const form = document.getElementById('productForm');
	if (!form) return;

	// Find the quantity input by its name attribute
	const quantityInput = form.querySelector('input[name="quantity"]');
	console.log('Quantity input found:', quantityInput);

	if (!quantityInput) return;

	// Find the add to cart button
	const addToCartBtn = form.querySelector(
		'.addToCartButton, button[type="submit"]'
	);
	console.log('Add to cart button found:', addToCartBtn);

	// Find buttons by their position or text content
	const allButtons = form.querySelectorAll('button');
	let decreaseBtn = null;
	let increaseBtn = null;

	allButtons.forEach(btn => {
		if (btn.textContent.includes('−') || btn.textContent.includes('-')) {
			decreaseBtn = btn;
		}
		if (btn.textContent.includes('+')) {
			increaseBtn = btn;
		}
	});

	console.log('Decrease button:', decreaseBtn);
	console.log('Increase button:', increaseBtn);

	// Add click handlers for quantity buttons
	if (decreaseBtn) {
		decreaseBtn.addEventListener('click', function (e) {
			e.preventDefault();
			let val = parseInt(quantityInput.value) || 1;
			if (val > 1) {
				quantityInput.value = val - 1;
			}
			console.log('Quantity decreased to:', quantityInput.value);
		});
	}

	if (increaseBtn) {
		increaseBtn.addEventListener('click', function (e) {
			e.preventDefault();
			let val = parseInt(quantityInput.value) || 1;
			let max = parseInt(quantityInput.max) || 99;
			if (val < max) {
				quantityInput.value = val + 1;
			}
			console.log('Quantity increased to:', quantityInput.value);
		});
	}

	// Handle input change
	quantityInput.addEventListener('change', function () {
		let val = parseInt(this.value) || 1;
		let min = parseInt(this.min) || 1;
		let max = parseInt(this.max) || 99;

		if (val < min) this.value = min;
		if (val > max) this.value = max;
	});

	// Handle add to cart
	if (addToCartBtn) {
		// Remove any existing event listeners (to prevent duplicates)
		const newAddToCartBtn = addToCartBtn.cloneNode(true);
		addToCartBtn.parentNode.replaceChild(newAddToCartBtn, addToCartBtn);

		newAddToCartBtn.addEventListener('click', async function (e) {
			e.preventDefault();
			e.stopPropagation();

			// Get the variant ID from the form
			const variantInput = form.querySelector('input[name="id"]');
			if (!variantInput || !String(variantInput.value).trim()) {
				alert(
					'This combination is not available. Please choose different options.'
				);
				return;
			}

			const variantId = String(variantInput.value).trim();
			const quantity = parseInt(quantityInput.value) || 1;

			console.log('Adding to cart:', { id: variantId, quantity: quantity });

			// Save original button text
			const originalText = newAddToCartBtn.textContent;

			try {
				// Update button state
				newAddToCartBtn.textContent = '~ Adding... ~';
				newAddToCartBtn.disabled = true;

				// Make AJAX request to add to cart
				const response = await fetch('/cart/add.js', {
					method: 'POST',
					headers: {
						'Content-Type': 'application/json',
						Accept: 'application/json',
						'X-Requested-With': 'XMLHttpRequest',
					},
					body: JSON.stringify({
						id: Number(variantId) || variantId,
						quantity: quantity,
					}),
				});

				const data = await parseShopifyCartAddResponse(response);
				if (!response.ok) {
					throw new Error(
						data.description ||
							data.message ||
							'Failed to add to cart'
					);
				}
				console.log('Added to cart:', data);

				// Show success message
				newAddToCartBtn.textContent = '~ Added! ~';

				// Update cart count in header
				await updateCartCount();

				// Open cart popout if it exists
				const cartPopOut = document.getElementById('cartPopOut');
				if (cartPopOut) {
					cartPopOut.classList.add('active');
					// If cartManager exists, use it to refresh
					if (window.cartManager) {
						await window.cartManager.refreshCartPopOut();
					}
				}

				// Reset button after 2 seconds
				setTimeout(() => {
					newAddToCartBtn.textContent = originalText;
					newAddToCartBtn.disabled = false;
				}, 2000);
			} catch (error) {
				console.error('Error adding to cart:', error);

				newAddToCartBtn.textContent = '~ Error ~';
				alert(error.message || 'Failed to add item to cart');

				setTimeout(() => {
					newAddToCartBtn.textContent = originalText;
					newAddToCartBtn.disabled = false;
				}, 2000);
			}
		});
	}

	// Function to update cart count in header
	async function updateCartCount() {
		try {
			const response = await fetch('/cart.js');
			const cart = await response.json();

			// Update cart icon
			const cartIcon = document.getElementById('cartIcon');
			if (cartIcon) {
				const countSpan = cartIcon.querySelector('.cartCount');
				if (countSpan) {
					countSpan.textContent = cart.item_count;
				} else {
					cartIcon.innerHTML = `~ Cart (${cart.item_count}) ~`;
				}
			}

			// Update any other cart count elements
			document.querySelectorAll('.cartCount, .cart-count').forEach(el => {
				el.textContent = cart.item_count;
			});

			if (window.cartManager && typeof window.cartManager.updateCartTotals === 'function') {
				window.cartManager.updateCartTotals(cart);
			}
		} catch (error) {
			console.error('Error updating cart count:', error);
		}
	}
});
